import { axiosAnonymous, axiosNode } from '../config/axiosConfig';
import { manejarErrorServicio } from '../utils/errorHandlerUtil';

const RUTA_PARAMETROS = 'parametros-generales';

export default {
  async crear(body) {
    try {
      const response = await axiosNode.post(RUTA_PARAMETROS, body);
      return response.data;
    } catch (error) {
      return await manejarErrorServicio(error);
    }
  },

  async buscarTodos() {
    try {
      const response = await axiosNode.get(RUTA_PARAMETROS);
      return response.data;
    } catch (error) {
      return await manejarErrorServicio(error);
    }
  },

  async actualizar(id, body) {
    try {
      const response = await axiosNode.put(`${RUTA_PARAMETROS}/id/${id}`, body);
      return response.data;
    } catch (error) {
      return await manejarErrorServicio(error);
    }
  },
  async obtenerParametrizacionInicial() {
    try {
      const response = await axiosAnonymous.get(
        `open/${RUTA_PARAMETROS}/informacion-basica`
      );
      return response.data;
    } catch (error) {
      return await manejarErrorServicio(error);
    }
  },
};
